var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"ads-block",attrs:{"id":"ads-block"}}),_c('MainAlert'),_c('TwitchAlert'),_c('DemoInfo'),(_vm.loaded)?_c('AppComponent'):_c('AppPreloader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }